import React from "react";

const SubmenuList = (props) => {
  const { subMenuList } = props;
  // const [windWidth, winHeight] = useWindowSize();
  const withOutArrowId = [
    "tent",
    "theater",
    "tablet",
    "backlitKeyboard",
    "openCloseLid",
  ];
  const hasRadioButton = subMenuList.some(item => item.menuType === "radioButton");
  // console.log(additionalHeadingText,'additionalHeadingText----')s
  return (
    <div className="accordionContent">
      {/* {additionalHeadingText ? <p>{additionalHeadingText}</p>:null} */}
      <ul className="subMenu" aria-hidden="true" role={hasRadioButton ? "radiogroup" : undefined}>
        {subMenuList.map((list) => {
          return (
            list.subMenuVisibility && (
              <li
                key={Math.random()}
                tabIndex={-1}
                defaultChecked={true}
                className={`subMenuBtn ${list.menuType}`}
                id={`menu_id_${list.id}`}
                aria-current="false"
                onKeyDown={(e) => {
                  if (e.key !== "Enter") {
                    return;
                  }
                  props.handleMenuClick(list);
                }}
                onClick={(event) => {
                  props.handleMenuClick(list, event);
                }}
              >
                {list.menuType === "radioButton" ? (
                  <>
                  <input
                  type={"radio"}
                  value={"product1"}
                  tabIndex={-1}
                  id={list.radioId}
                  className="radioFocus"
                  name={list.radioName}
                  />
                  <label id="tower_tab" htmlFor={list.radioId}> {list.title}</label>
                  </>
                ) : ((window.mob || window.innerHeight > window.innerWidth) &&
                    props.orentation === 0) ||
                  window.innerWidth < 935 ? (
                  <>
                    {!withOutArrowId.includes(list.id) && (
                      <div className="accordia_icon">
                        <img
                          className="arrow"
                          alt="arrow"
                          src="images/spacer.png"
                          id={`accordianIcon_${list.id}`}
                        />
                      </div>
                    )}
                    {list.title}
                  </>
                ) : (
                  list.title
                )}
              </li>
            )
          );
        })}
      </ul>
    </div>
  );
};

export default SubmenuList;
